import { useTranslation } from 'react-i18next';
import Reveal from '@/components/base/Reveal';

export default function IntroSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto grid w-full max-w-content grid-cols-1 items-center gap-12 px-4 md:px-6 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <div className="relative">
            <div className="overflow-hidden rounded-lg border border-background-200">
              <div className="h-72 w-full md:h-96">
                <img
                  src="https://www.sn-metall.de/mediapool/126/1269216/resources/big_56616629_2_500-375.jpg"
                  alt="Gefertigte Blechbauteile aus der Produktion von S+N Metall"
                  className="h-full w-full object-cover"
                />
              </div>
            </div>
            <div className="absolute -bottom-5 -right-3 hidden items-center gap-3 rounded-lg bg-primary-500 px-5 py-4 sm:flex md:-right-6">
              <i className="ri-time-line text-2xl text-background-50" />
              <div className="leading-tight">
                <p className="font-heading text-sm font-bold text-background-50">{t('home.hero.badge')}</p>
                <p className="text-[11px] uppercase tracking-[0.14em] text-background-100">S+N Metall</p>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            <span className="h-px w-6 bg-current" />
            {t('home.intro.eyebrow')}
          </span>
          <h2 className="mt-4 text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
            {t('home.intro.title')}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-foreground-600">{t('home.intro.p1')}</p>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">{t('home.intro.p2')}</p>

          <ul className="mt-7 space-y-3">
            {[t('home.intro.point1'), t('home.intro.point2'), t('home.intro.point3')].map((point) => (
              <li key={point} className="flex items-start gap-3 text-sm text-foreground-800">
                <i className="ri-check-line mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-accent-100 text-sm text-accent-700" />
                {point}
              </li>
            ))}
          </ul>

          <p className="mt-7 rounded-lg border border-background-200 bg-background-100 p-4 text-sm leading-relaxed text-foreground-700">
            {t('home.intro.p3')}
          </p>
        </Reveal>
      </div>
    </section>
  );
}